import UsuarioService from '@/services/UsuarioService';

export const usuario = {
    namespaced: true,
    actions: {
        newUsuario(){
            return UsuarioService.newUsuario();
        },
        getAllUsuario () {
            return UsuarioService.getAllUsuario()
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        getUsuario ({id}) {
            return UsuarioService.getUsuario(id)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        postUsuario ({payload}) {
            return UsuarioService.postUsuario(payload)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        postUsuarioRetornar ({dispatch}, payload) {
            return UsuarioService.postUsuarioRetornar(payload)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        putUsuario ({dispatch}, payload) {
            return UsuarioService.putUsuario(payload)
            .then(
                response => {
                    return response;
                },
                error => {
                    console.error(error);
                    return Promise.reject(new Error(error));
                }
            );
        },
        ativarUsuario ({dispatch}, id) {
            return UsuarioService.ativarUsuario(id)
            .then(
                response => {
                    return response;
                },
                error => {
                    console.error(error);
                    return Promise.reject(new Error(error));
                }
            );
        },
        desativarUsuario ({dispatch}, id) {
            return UsuarioService.desativarUsuario(id)
            .then(
                response => {
                    return response;
                },
                error => {
                    console.error(error);
                    return Promise.reject(new Error(error));
                }
            );
        },
        buscarUsuarioLdapPorEmail ({dispatch}, email) {
            return UsuarioService.buscarUsuarioLdapPorEmail(email)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                        return Promise.reject(new Error(error));
                    }
                );
        },
    },
    state: {},
    mutations: {},
};
